/**
 * Public barrel export for MobileMultiSelect.
 * @module components/shared/MobileFilterSheet/MobileMultiSelect
 */
export { default } from "./MobileMultiSelectContainer";
